import JassEnum from './enum';

/**
 * type blendmode
 */
export default class JassBlendMode extends JassEnum {}
